export enum PermissionQueryTypeEnum {
  In = 'IN',
  NotIn = 'NOT_IN',
}
